// extracted by mini-css-extract-plugin
module.exports = {"excerpt":"excerpt-m__excerpt__2Y5mz"};